// extracted by mini-css-extract-plugin
module.exports = {"flex":"style_flex__eTZa6","ml":"style_ml__1L-sZ"};